import { AfterViewInit, Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ngx-view-qrcode",
  styleUrls: ["./view-qrcode.component.scss"],
  templateUrl: "./view-qrcode.component.html",
})
export class ViewQRCodeComponent implements OnInit, AfterViewInit {
  @Input() qrdata: string;
  @Input() title?: string = "";

  constructor() {}

  ngOnInit(): void {
    // console.log("ViewQRCodeComponent/qrcode:", this.qrdata);
  }

  ngAfterViewInit() {}
}
